import { useState } from "react";
import RoleToggle from "../../../components/RoleToggle";

type InputProps = {
  label?: string;
  value: string;
  type?: string;
  className?: string;
};

const InputField = ({ label, value, type, className = "" }: InputProps) => (
  <div className={` flex justify-between items-center space-y-4 ${className}`}>
    {label && (
      <label className="w-full text-base  text-[#212121]">{label}</label>
    )}
    <input
      type={type}
      value={value}
      className={`px-4 py-2 text-sm w-full rounded-full outline-none bg-white border border-[#D8D8D8]`}
    />
  </div>
);

export default function BankDetails() {
  const [isEdit, setIsEdit] = useState(true);
  const [activeRole, setActiveRole] = useState("UPI");
  const roles = ["UPI", "Cards", "Banks"];
  return (
    <div className=" w-[47rem] mx-auto text-[#1E293B] space-y-8 py-4 ">
      <div className="flex justify-center items-center">
        <RoleToggle
          options={roles}
          active={activeRole}
          onChange={setActiveRole}
        />
      </div>
      {activeRole === "UPI" && (
        <>
          <div className="flex justify-between items-center">
            <p className="text-xs font-semibold text-[#212121]/70">
              UPI DETAILS
            </p>
            <button className="bg-[#FBD037] text-[#212121] text-sm font-semibold px-5 py-1.5 rounded-full">
              Add New
            </button>
          </div>
          <div className="divide-y divide-[#212121]/20 space-y-2">
            <InputField label="Bank Name" value="Al Rajhi Bank" />
            <InputField label="Bank Holder Name" value="Jhon Devid" />
            <InputField label="Bank Account Number" value="9854000025225" />
            <InputField label="Swift Code" value="NCBKSAJEXXX" />
            <div className="flex justify-between items-center space-y-4">
              <label className="w-full text-base text-[#212121]">Iban No</label>
              <div className="flex items-center w-full gap-2">
                <InputField value="SA" className="w-1/3" />
                <InputField value="0380000000608010167519" className="w-full" />
              </div>
            </div>
          </div>
        </>
      )}
      {activeRole === "Cards" && (
        <>
          <div className="flex justify-between items-center">
            <p className="text-xs font-semibold text-[#212121]/70">
              CARD DETAILS
            </p>
            <button
              onClick={() => setIsEdit(!isEdit)}
              className="bg-[#FBD037] text-[#212121] text-sm font-semibold px-5 py-1.5 rounded-full"
            >
              Add New
            </button>
          </div>
          <div className="divide-y divide-[#212121]/20 space-y-2">
            <InputField label="Card Number" value="Al Rajhi Bank" />
            <InputField type="date" label="Expiry Date" value="Jhon Devid" />
            <InputField label="CVV" value="9854000025225" />
          </div>
        </>
      )}
      {activeRole === "Banks" && (
        <>
          <div className="flex justify-between items-center">
            <p className="text-xs font-semibold text-[#212121]/70">
              BANK DETAILS
            </p>
            <button
              onClick={() => setIsEdit(!isEdit)}
              className="bg-[#FBD037] text-[#212121] text-sm font-semibold px-5 py-1.5 rounded-full"
            >
              Add New
            </button>
          </div>
          <div className="divide-y divide-[#212121]/20 space-y-2">
            <InputField label="Bank Name" value="Al Rajhi Bank" />
            <InputField label="Bank Holder Name" value="Jhon Devid" />
            <InputField label="Bank Account Number" value="9854000025225" />
            <InputField label="Swift Code" value="NCBKSAJEXXX" />
            <div className="flex justify-between items-center space-y-4">
              <label className="w-full text-base text-[#212121]">Iban No</label>
              <div className="flex items-center w-full gap-2">
                <InputField value="SA" className="w-1/3" />
                <InputField value="0380000000608010167519" className="w-full" />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
